// eslint-disable-next-line no-shadow
export enum Role {
  superuser = 'superuser',
  admin = 'admin',
  operator = 'operator'
}
